import {RemoteGetLifeplaceLink} from 'data/usecases/private/lifeplace/remote-get-lifeplace-link';
import {GetLifeplaceLink} from 'domain/usecases/private/lifeplace/get-lifeplace-link';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {LifeplaceEndpoints} from '../../endpoints';

export const makeGetLifeplaceLink = (): GetLifeplaceLink =>
	new RemoteGetLifeplaceLink(
		makeBFFApiUrl(LifeplaceEndpoints.lifePlaceLink),
		makeAuthorizeHttpClientDecorator(),
	);
